import React from 'react';
import { Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import { Content } from '../shared/Content';
import GenericError from '../shared/Errors/GenericError';

const InvitationExpired = () => {
    const statusCode = 401;

    return (
        <Box
            sx={{
                backgroundColor: '#F4F5F6',
                inlineSize: 'unset',
                paddingTop: '80px',
                paddingBottom: '80px',
            }}
            id="invitation-expired-container"
            className="b-container-content">
            <GenericError
                id="invitation-expired-error"
                title={Content.emailInvitationError[statusCode].headerText}>
                <Box sx={{ paddingBottom: '24px' }}>
                    {Content.emailInvitationError[statusCode].text}
                </Box>
                <Box sx={{ paddingBottom: '24px' }}>
                    {Content.emailInvitationError[statusCode].cardDataSubText}
                </Box>
            </GenericError>
        </Box>
    );
};

export default InvitationExpired;
